import { Box, Button, TableRow, useTheme } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import LoadingScreen from "minimals-template/components/LoadingScreen"
import {
    AssetRegisterRowFirstCell,
    AssetRegisterRowLastCell,
    AssetRegisterRowMiddleCell,
} from "lib/@components/paging/paged-table/two-tone/asset-register-table-cells"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import { Frag } from "lib/@components/slot/frag"
import { FileIconForTable } from "./file-icon-for-table"
import { UserAvatar } from "minimals-template/components/user-avatar"
import { AssetRegisterRowEnd, AssetRegisterRowMiddle, AssetRegisterRowStart } from "slot-definitions"
import { Secure } from "lib/authorization/secure"
import { IfTooltip } from "lib/if-tooltip"
import { useIsAnythingBeingMapped } from "routes/asset-register/plugins/asset-mapping/use-is-anything-being-mapped"
import { useIsAnythingRefining } from "routes/asset-register/plugins/asset-mapping/use-is-anything-refining"
import { RegimeDraftLockHide } from "routes/regime/regime-draft-locking/regime-draft-lock-hide"

export function AssetRegisterRow({
    row,
    removing,
    showIcon,
    name,
    numberOfAssets,
    user,
    remove,
    removeDemand = "manageAssetRegister",
}) {
    const theme = useTheme()
    const isMapping = useIsAnythingBeingMapped()
    const isRefining = useIsAnythingRefining()

    if (removing) return <LoadingScreen description="Removing file" />

    return (
        <TableRow data-cy="asset-register-row">
            <AssetRegisterRowFirstCell>
                <Box display="flex" alignItems="center" data-cy="imported-file-icon">
                    {showIcon ? <FileIconForTable row={row} theme={theme} /> : <Frag />}
                    <TruncatedTypography
                        sx={{
                            ml: 1,
                        }}
                    >
                        {name}
                    </TruncatedTypography>
                </Box>
            </AssetRegisterRowFirstCell>
            <AssetRegisterRowStart.Slot row={row} />
            <AssetRegisterRowMiddleCell>{numberOfAssets}</AssetRegisterRowMiddleCell>
            <AssetRegisterRowMiddle.Slot row={row} />
            <AssetRegisterRowMiddleCell>{<UserAvatar user={user.user} />}</AssetRegisterRowMiddleCell>
            <AssetRegisterRowEnd.Slot row={row} />
            <AssetRegisterRowLastCell>
                <Secure hide demand={removeDemand} fallback={<Frag />}>
                    <RegimeDraftLockHide>
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <IfTooltip
                                condition={isMapping || isRefining}
                                title="This file is currently being processed by Mobiliser and cannot be deleted until processing is complete."
                            >
                                <Button
                                    disabled={isMapping || isRefining}
                                    onClick={() => remove(row)}
                                    color="secondary"
                                    startIcon={<Iconify icon="mdi:delete" />}
                                    data-cy="remove-file-button"
                                >
                                    Remove
                                </Button>
                            </IfTooltip>
                        </Box>
                    </RegimeDraftLockHide>
                </Secure>
            </AssetRegisterRowLastCell>
        </TableRow>
    )
}
